/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import { useSelector } from "react-redux";
import { isManagerCompany } from "../../../utils/auth";
import TaxCompanySchedule from "../../../components/TaxPortal/TaxDashboard/TaxCompanySchedule";
import TaxContacts from "../../../components/TaxPortal/TaxContacts";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import TaxCompanyScheduleList from "../../../components/TaxPortal/TaxDashboard/TaxCompanyScheduleList";
import TaxpayerScheduleCategories from "../../../components/TaxPortal/Taxpayer/TaxpayerScheduleCategories";

const TaxDashboard = (props) => {
  // const role = "ADMIN";
  const history = useHistory();

  const [activeTab, setActiveTab] = useState("calendar");

  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
  );


  const _setActiveTab = (value) => {
    history.push(`/tax-portal/schedules?tab=${value}`);
  };

  const tabList = [
    {
      label: "일정관리-캘린더",
      action: _setActiveTab,
      value: "calendar",
    },
    {
      label: "일정관리-목록",
      action: _setActiveTab,
      value: "list",
    },
    {
      label: "카테고리 관리",
      action: _setActiveTab,
      value: "schedule-category",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);


  return (
    <div className="tax-portal tax-schedule-page">
      <PageHeader title={`안녕하세요, ${user?.name}님.`}
        activeTab={activeTab}
        tabList={tabList}
      />
      {user?.type > 1 && isManagerCompany() && (
        <>
          {activeTab !== "schedule-category" && <TaxContacts />}
          {activeTab === "list" && <TaxCompanyScheduleList />}
          {activeTab === "calendar" && <TaxCompanySchedule />}
          {activeTab === "schedule-category" && <TaxpayerScheduleCategories />}
        </>
      )}
    </div >
  );
};

export default TaxDashboard;
